import { Card } from '@/components/ui/card'
import avatarBackground from '@/assets/dashboard/AvatarBackground.png'
import { ProfileWelcomeCardBaseProps, ProfileWelcomeCardBase } from './ProfileWelcomeCardBase'
import { InfoTooltip } from '@/components/ui/info-tooltip'

/**
 * Desktop version of ProfileWelcomeCard
 * Uses base logic but has desktop-specific UI with assets display
 */
export const ProfileWelcomeCardDesktop = ({ profile }: ProfileWelcomeCardBaseProps) => {
  const displayName = ProfileWelcomeCardBase.getDisplayName(profile)

  return (
    <div className="flex">
      <Card
        variant="default"
        padding="none"
        className="rounded-none shadow-none border border-white dark:border-[#1c1c1c] h-[264px] relative overflow-hidden flex-1 flex flex-col bg-[rgba(255,255,255,0.7)] dark:bg-[rgba(28,28,28,0.7)]"
      >
        <div
          className="absolute inset-0 opacity-100"
          style={{
            backgroundImage: `url(${avatarBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
        <div className="relative z-10 flex-1">
          <div className="absolute right-4 top-4 z-20">
            <InfoTooltip content="Your personalized dashboard overview." ariaLabel="Welcome card info" />
          </div>
          {/* Left column */}
          <div className="absolute left-[40px] top-[40px] flex flex-col items-start justify-between h-[184px]">
              {/* Avatar */}
              <div className="flex-shrink-0">
{profile?.profile_picture_url ? (
                    <img 
                      src={profile.profile_picture_url}
                    alt="User profile" 
                    className="w-[72px] h-[72px] rounded-full object-cover"
                  />
                ) : (
                  <div className="w-[72px] h-[72px] rounded-full bg-primary/10 flex items-center justify-center text-2xl font-bold text-primary border border-primary/20">
                    {profile?.first_name?.[0]}{profile?.last_name?.[0] || ''}
                  </div>
                )}
              </div>
              
              {/* Welcome Text */}
              <div className="flex flex-col items-start">
                <p className="font-plus-jakarta font-normal text-[30px] leading-[40px] tracking-[-0.28px] text-[rgba(45,41,35,0.64)] dark:text-[rgba(253,253,253,0.64)]">
                  Welcome back,
                </p>
                <h3 className="font-plus-jakarta font-semibold text-[30px] leading-[40px] tracking-[-0.28px] text-[#2d2923] dark:text-[#fdfdfd] whitespace-nowrap">
                  {displayName}
                </h3>
              </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
